import { convertToHexColor, getReadableTextColor } from '@libs/store';
import { AppointmentStatusColor } from '@ffd/api-client';

export function getStatusColorHex(statusColor?: AppointmentStatusColor | null): string | null {
  if (!statusColor) {
    return null;
  }
  return convertToHexColor(statusColor);
}

export function getStatusTextColor(statusColor?: AppointmentStatusColor | null): string {
  const statusColorHex = getStatusColorHex(statusColor);
  if (!statusColorHex) {
    return '#000000';
  }
  return getReadableTextColor(statusColorHex);
}

export function getStatusAbbreviation(statusColor?: AppointmentStatusColor | null): string {
  return statusColor?.statusCode || '';
}
